import { createSlice } from "@reduxjs/toolkit";
import { appendCategoryList, clearCategoriesByNameAI, clearSearchCategoriesFunc, getCategoriesByNameAI, getCategoriesFunc, getCategoriesSelectFunc, getCategoryThunk, searchCategoriesFunc } from "./thunk";
import { StorageKeys } from "utils/enums";

export const initialState: any = {
  categories: localStorage.getItem(StorageKeys.categories) ? JSON.parse(localStorage.getItem(StorageKeys.categories)!) : [],
  searchList: [],
  categoriesSearchAI: [],
  counts: 0,
  categoryList: []
};

const CategorySlice = createSlice({
  name: 'CategorySlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCategoriesByNameAI.fulfilled, (state: any, action: any) => {
      state.categoriesSearchAI = [];
      state.categoriesSearchAI = action.payload;
    });
    builder.addCase(clearCategoriesByNameAI.fulfilled, (state: any, action: any) => {
      state.categoriesSearchAI = [];
    });
    builder.addCase(getCategoryThunk.fulfilled, (state: any, action: any) => {
      state.categoryList = action.payload.data;
    });

    builder.addCase(getCategoryThunk.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    // builder.addCase(getCategoriesFunc.fulfilled, (state: any, action: any) => {
    //   for (let item of action?.payload.data) {
    //     const catIndex = state.categories.findIndex((x: any) => x._id === item._id);
    //     if (catIndex === -1) {
    //       state.categories.push(item);
    //     }
    //   }
    //   localStorage.setItem(StorageKeys.categories, JSON.stringify(state.categories));
    // });

    builder.addCase(getCategoriesFunc.fulfilled, (state: any, action: any) => {
      const data = action?.payload?.data;
      if (Array.isArray(data)) {
        for (let item of data) {
          const catIndex = state.categories.findIndex((x: any) => x._id === item._id);
          if (catIndex === -1) {
            state.categories.push(item);
          }
        }
        localStorage.setItem(StorageKeys.categories, JSON.stringify(state.categories));
      } else {
        console.warn("getCategoriesFunc fulfilled but data is not an array", data);
      }
    });
    builder.addCase(getCategoriesSelectFunc.fulfilled, (state: any, action: any) => {
      state.form = action.payload;
    });
    builder.addCase(searchCategoriesFunc.fulfilled, (state: any, action: any) => {
      state.searchList = action.payload;
      for (let category of action.payload) {
        if (category.childCategoriesByParent) {
          let keys = Object.keys(category.childCategoriesByParent);
          for (let key of keys) {
            for (let item of category.childCategoriesByParent[key]) {
              const catIndex = state.categories.findIndex((x: any) => x._id === item._id);
              if (catIndex === -1) {
                state.categories.push(item);
              }
            }
          }
        }
      }
      localStorage.setItem(StorageKeys.categories, JSON.stringify(state.categories));
    });
    builder.addCase(clearSearchCategoriesFunc.fulfilled, (state: any, action: any) => {
      state.searchList = action.payload;
    });
    builder.addCase(appendCategoryList.fulfilled, (state: any, action: any) => {
      const category = action.payload;
      if (category?.childCategoriesByParent) {
        let keys = Object.keys(category.childCategoriesByParent);
        for (let key of keys) {
          for (let item of category.childCategoriesByParent[key]) {
            const catIndex = state.categories.findIndex((x: any) => x._id === item._id);
            if (catIndex === -1) {
              state.categories.push(item);
            }
          }
        }
        localStorage.setItem(StorageKeys.categories, JSON.stringify(state.categories));
      }
    });
  }
});

export default CategorySlice.reducer;